import { render } from "./CDDetailsContainer.vue?vue&type=template&id=197aab2d&scoped=true"
import script from "./CDDetailsContainer.vue?vue&type=script&lang=js"
export * from "./CDDetailsContainer.vue?vue&type=script&lang=js"

import "./CDDetailsContainer.vue?vue&type=style&index=0&id=197aab2d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197aab2d"]])

export default __exports__